<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">

                    <div v-if="isLoading" class="text-center py-5">
                        <div class="spinner-border text-success" role="status">
                            <span class="visually-hidden">Cargando...</span>
                        </div>
                    </div>

                    <div v-else class="table-responsive p-0">
                        <UsersTable
                            :users="pagedRows"
                            @toggle-status="handleToggleStatus"
                            @request-reset="handleRequestReset"
                        />
                    </div>

                    <div v-if="!isLoading && filteredRows.length > 0" class="card-footer d-flex justify-content-between align-items-center">
                        <small class="text-muted">
                            Mostrando {{ (currentPage - 1) * itemsPerPage + 1 }}–{{ Math.min(currentPage * itemsPerPage, filteredRows.length) }} de {{ filteredRows.length }} registros.
                        </small>

                        <nav aria-label="Page navigation example">
                            <ul class="pagination pagination-info">
                                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                    <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">
                                        <i class="fa fa-angle-left"></i>
                                    </a>
                                </li>
                                <li
                                    class="page-item"
                                    v-for="page in visiblePages"
                                    :key="page"
                                    :class="{ active: currentPage === page }"
                                >
                                    <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                                </li>
                                <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                    <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">
                                        <i class="fa fa-angle-right"></i>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UsersTable from './components/Table.vue'; // Asumiendo la ruta correcta
import axios from 'axios';
import Swal from 'sweetalert2';
const companyId=localStorage.getItem('companyId');
export default {
    name: "UsersView",
    components: { UsersTable },
    data() {
        return {
            users: [], // Almacena TODOS los usuarios cargados
            isLoading: true,
            // Variables de Paginación Local (Frontend)
            currentPage: 1,
            itemsPerPage: 10,
            branchId:parseInt(localStorage.getItem('branchId')),
            userRole:parseInt(localStorage.getItem('userLevel'))
        };
    },
    computed: {
        // 1. No implementamos filtrado (searchTerm) por ahora, pero la estructura está lista.
        // Si necesitaras buscar, aquí iría la lógica.
        filteredRows() {
            return this.users;
        },

        // 2. PAGINACIÓN: Muestra solo los elementos de la página actual
        pagedRows() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.filteredRows.slice(start, end);
        },

        // 3. Totales de Páginas
        totalPages() {
            return Math.ceil(this.filteredRows.length / this.itemsPerPage);
        },

        // 4. Mostrar solo algunas páginas en el menú
        visiblePages() {
            const range = 2;
            let start = Math.max(1, this.currentPage - range);
            let end = Math.min(this.totalPages, this.currentPage + range);

            const pages = [];
            for (let i = start; i <= end; i++) {
                pages.push(i);
            }
            return pages;
        }
    },
    mounted() {
        this.fetchUsers();
    },
    methods: {
        // === 1. Lógica de Carga de Usuarios ===
        async fetchUsers() {
            this.isLoading = true;
            const token = localStorage.getItem("accessToken");
            const config = { headers: { 'Authorization': `Bearer ${token}` } };

            try {
                // Endpoint para obtener TODOS los usuarios de la compañía
                let qryParams;
                if(this.userRole==2){
                    qryParams='users?company='+companyId+'&fk_branch_id='+this.branchId;
                }else{
                     qryParams='users?company='+companyId;
                }
                const response = await axios.get(this.$store.state.apiURL +qryParams , config);

                // Mapeamos los datos para asegurar que is_active es numérico para el componente hijo
                this.users = response.data.map(user => ({
                    ...user,
                    is_active: parseInt(user.is_active),
                    role_name: user.role // Asumiendo que el campo 'role' viene anidado
                }));

                this.currentPage = 1;

            } catch (error) {
                console.error("Error al cargar usuarios:", error.response || error);
                this.handleSessionError(error);
            } finally {
                this.isLoading = false;
            }
        },

        // === 2. Controladores de Paginación ===
        changePage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
            }
        },

        // === 3. Manejo de Acciones de la Tabla (Toggle Status) ===
        async handleToggleStatus(user) {
            const newStatus = user.is_active === 1 ? 0 : 1;
            const actionText = newStatus === 1 ? 'activar' : 'suspender';

            Swal.fire({
                title: `Confirmar ${actionText}`,
                text: `¿Estás seguro de que deseas ${actionText} al usuario ${user.username}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: newStatus === 1 ? '#2dce89' : '#f5365c',
                cancelButtonColor: '#adb5bd',
                confirmButtonText: `Sí, ${actionText}`
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const token = localStorage.getItem("accessToken");
                    const apiURL = this.$store.state.apiURL;
                    const reqConfig = { headers: { 'Authorization': `Bearer ${token}` } };

                    try {
                        // 🛑 Llamada a la API para cambiar el estado 🛑
                        await axios.put(`${apiURL}users/${user.id}`, { is_active: newStatus }, reqConfig);

                        // Actualización local del modelo de datos para reflejar el cambio en la tabla
                        const userIndex = this.users.findIndex(u => u.id === user.id);
                        if (userIndex !== -1) {
                            const updatedUsers = [...this.users];
                            // 2. Crear una copia del usuario y actualizar el estado
                            updatedUsers[userIndex] = { ...user, is_active: newStatus };
                            // 3. Reemplazar la referencia completa del array (DISPARA LA REACTIVIDAD)
                            this.users = updatedUsers;
                        }

                        Swal.fire('Éxito', `El usuario ha sido ${actionText === 'activar' ? 'activado' : 'suspendido'}.`, 'success');

                    } catch (err) {
                        console.error(`Error al ${actionText} usuario:`, err.response || err);
                        Swal.fire('Error', `No se pudo ${actionText} al usuario.`, 'error');
                    }
                }
            });
        },

        // === 4. Manejo de Acciones de la Tabla (Reset Password) ===
        async handleRequestReset(user) {
            if (!user.id || !user.email) return;

            Swal.fire({
                title: 'Confirmar Restablecimiento',
                text: `Se enviará un enlace de restablecimiento de contraseña al correo ${user.email}. ¿Deseas continuar?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#5e72e4',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, enviar enlace'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const token = localStorage.getItem("accessToken");
                    const apiURL = this.$store.state.apiURL;
                    const userId = user.id;
                    const reqConfig = { headers: { 'Authorization': `Bearer ${token}` } };

                    try {
                        // 🛑 Llamada a la API para solicitar el reseteo 🛑
                        await axios.post(`${apiURL}password/request/`, {
                            email:user.email,
                            id:userId
                        }, reqConfig);

                        Swal.fire('Enviado', `El enlace de restablecimiento ha sido enviado a ${user.email}.`, 'success');

                    } catch (err) {
                        console.error('Error al solicitar restablecimiento:', err.response || err);
                        const errorText = (err.response && err.response.data && err.response.data.message)
                                         ? err.response.data.message : 'No se pudo enviar el enlace. Verifique que el email sea válido.';
                        Swal.fire('Error', errorText, 'error');
                    }
                }
            });
        },

        // Manejo de error de sesión (mantenido)
        handleSessionError(error) {
            const self = this;
            if (error.response && error.response.status === 401) {
                Swal.fire({
                    title: 'Sesión',
                    text: 'El tiempo de sesión ha vencido, ingresa nuevamente.',
                    icon:'warning',
                    confirmButtonColor:'#bf4f51',
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });
            }
        }
    },
};
</script>